import React from "react";
import { Button } from "primereact/button";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import localeText from "../../../../../locale";

const EvaluationButton = ({ showBusinessSquare = false, visible = true }) => {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const handleClick = async () => {
    setIsLoading(true);
    if (showBusinessSquare) {
      history.push("/dashboard-store/settings?tab=businessDiagnosis");
    } else {
      history.push("/dashboard-editprofile/profileAnalysis/analysis");
    }
  };

  if (!visible) {
    return null;
  }

  return (
    <>
      <Button
        label={localeText("doTheDiagnosis")}
        style={{
          backgroundColor: "var(--theme-primary, #1DAF61)",
          color: "#fff",
          padding: "10px 20px",
        }}
        className="p-no-outline border-none border-round-md"
        onClick={handleClick}
        loading={isLoading}
      />
    </>
  );
};

export default React.memo(EvaluationButton);
